import React, { PropsWithChildren } from 'react';
import Nav from '../Nav';
import Footer from '../Footer';
import { NavLink } from '../NavRoot';
import { NavDrawerProps } from '../Nav/NavDrawer';
import { DrawerProvider } from '../../UI/Drawer';

export type LayoutVariant = 'base' | 'activate';

const Layout: React.FC<
  PropsWithChildren & {
    hideNav?: boolean;
    hideFooter?: boolean;
    minimalFooter?: boolean;
    cartCount: number;
    showCart: () => void;
    onEmailSubscribe: (email: string) => Promise<{ status: string }>;
    isMinimal?: boolean;
    logoLink?: string | React.ReactNode | undefined;
    clickToCall?: boolean | { hideChat?: boolean };
    callNumber?: string;
    navLeft?: JSX.Element;
    navRight?: JSX.Element;
    showShopButton?: boolean;
    navLinks?: NavLink[];
    navDrawers?: NavDrawerProps[];
    variant?: LayoutVariant;
  }
> = ({
  children,
  isMinimal = false,
  hideNav = false,
  hideFooter = false,
  minimalFooter = false,
  showShopButton = true,
  cartCount,
  showCart,
  onEmailSubscribe,
  logoLink,
  clickToCall,
  callNumber,
  navLeft,
  navRight,
  navLinks,
  navDrawers,
  variant,
  ...props
}) => {
  return (
    <DrawerProvider>
      <div className="flex min-h-screen flex-col p-0" {...props}>
        {!hideNav && (
          <Nav
            cartCount={cartCount}
            showCart={showCart}
            isMinimal={isMinimal}
            logoLink={logoLink}
            clickToCall={clickToCall}
            callNumber={callNumber}
            navLeft={navLeft}
            navRight={navRight}
            showShopButton={showShopButton}
            navLinks={navLinks}
            navDrawers={navDrawers}
          />
        )}
        <main className="flex-grow">{children}</main>
        {!hideFooter && (
          <Footer
            isMinimal={minimalFooter}
            onSubscribe={onEmailSubscribe}
            variant={variant}
          />
        )}
      </div>
    </DrawerProvider>
  );
};

export default Layout;
